import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Chip,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Theme
} from '@material-ui/core';
import {red} from '@material-ui/core/colors';
import clsx from 'clsx';
import React from 'react';
import {makeStyles} from '@material-ui/styles';
import {TableEditBar} from '../../../components/TableEditBar';
import {PaginatiorInfo} from '../../../graphql/common.datatypes';
import BlockOutlinedIcon from '@material-ui/icons/BlockOutlined';
import {GroupMember, GroupMemberRoleTypes, TourRoleTypes} from '../../../graphql/groups.datatypes';
import {formatDate,formatMoney} from '../../../utils/formatters';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'relative',
    },
    content: {
        padding: 0
    },
    inner: {
      [theme.breakpoints.up('md')]: {
        minWidth: 700,
      },
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    },
    cancelled: {
        backgroundColor: red[100],
        '&:hover': {
            backgroundColor: red[200]
        }
    },
    chip: {
        backgroundColor: red[200]
    },
}));

const Results = (props: {
    className?: string,
    groupsMembers: GroupMember[],
    paginatorInfo?: PaginatiorInfo,
    setPage?: (page: number) => void,
    rowsPerPage?: number,
    setRowsPerPage?: (rowsPerPage: number) => void,
    handleUpdateMember: (memberId: number, authorised?: boolean, cancelled?: boolean) => void,
    hideGroupColumn?: boolean,
    isAdmin?: boolean,
    canEdit?: boolean,
    groupRef?: string,
}) => {
    const {className, rowsPerPage, setPage, setRowsPerPage, paginatorInfo, groupsMembers, handleUpdateMember, hideGroupColumn, isAdmin, canEdit, groupRef, ...rest} = props;
    const classes = useStyles();

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        if (setPage) setPage(page + 1);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        if (setRowsPerPage) setRowsPerPage(Number(event.target.value));
    };

    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Card>
                <CardHeader
                    title={'Group Members'}
                />
                <Divider/>
                <CardContent className={classes.content}>
                    <PerfectScrollbar>
                        <div className={classes.inner}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Name</TableCell>
                                        {!hideGroupColumn && (<TableCell>Group</TableCell>)}
                                        {isAdmin && (<TableCell>Group Role</TableCell>)}
                                        <TableCell>Tour Role</TableCell>
                                        <TableCell style={{width: 130}}>Check In</TableCell>
                                        <TableCell style={{width: 130}}>Check Out</TableCell>
                                        {isAdmin && (<TableCell style={{width: 100}}>Cost</TableCell>)}
                                        <TableCell>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {groupsMembers.map(groupMember => {
                                        return (
                                            <TableRow
                                                hover={!groupMember.cancelled}
                                                key={groupMember.id}
                                                className={groupMember.cancelled ? classes.cancelled : ''}
                                            >
                                                <TableCell>
                                                    {groupMember.first_name} {groupMember.last_name}
                                                    {groupMember.cancelled && (
                                                        <React.Fragment>
                                                            <br/><Chip icon={<BlockOutlinedIcon/>} label="cancelled"
                                                                       className={classes.chip} size="small"/>
                                                        </React.Fragment>
                                                    )}
                                                </TableCell>
                                                {!hideGroupColumn && (<TableCell>{groupMember.group!.name}</TableCell>)}
                                                {isAdmin && (<TableCell>{GroupMemberRoleTypes[groupMember.group_role].name}</TableCell>)}
                                                <TableCell>{TourRoleTypes[groupMember.tour_role].name}</TableCell>
                                                <TableCell>{groupMember.roomMember ? formatDate(groupMember.roomMember.start_date) : ''}</TableCell>
                                                <TableCell>{groupMember.roomMember ? formatDate(groupMember.roomMember.end_date) : ''}</TableCell>
                                                {isAdmin && (<TableCell>{groupMember.roomMember ? formatMoney(groupMember.roomMember.cost!,true) : 0}</TableCell>)}
                                                <TableCell>
                                                    <Button color="primary" variant="outlined" onClick={(event) => {
                                                        event.stopPropagation();
                                                        handleUpdateMember(groupMember.id, true, undefined);
                                                    }}>Approve</Button>
                                                    <Button color="primary" variant="outlined" onClick={(event) => {
                                                        event.stopPropagation();
                                                        handleUpdateMember(groupMember.id, undefined, true);
                                                    }}>Decline</Button>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </div>
                    </PerfectScrollbar>
                </CardContent>

                {paginatorInfo && rowsPerPage && (
                    <CardActions className={classes.actions}>
                        <TablePagination
                            component="div"
                            count={paginatorInfo.total}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                            page={paginatorInfo.currentPage - 1}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[25, 50, 100]}
                        />
                    </CardActions>
                )}

            </Card>
            <TableEditBar selected={[]}/>
        </div>
    );
};

export default Results;
